import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import { $html, $body } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: ({ scroll, limit, velocity, direction, progress }) => this.onScroll({ scroll, limit, velocity, direction, progress }),
        });

        // Force scroll to top
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
            window.scrollTo(0, 0);
        }

        this.initScrollToElements();

        window.addEventListener('scroll-start', () => { this.start(); });
        window.addEventListener('scroll-stop', () => { this.stop(); });
        window.addEventListener('scroll-resize', () => { this.resize(); });
    }

    start() {
        this.scroll.start();
    }

    stop() {
        this.scroll.stop();
    }

    resize() {
        this.scroll.resize();
    }

    onScroll({ scroll, limit, velocity, direction, progress }) {
        // if ($body.classList.contains('single-post')) {
        //     document.querySelector('.o-navbar_progress').style.setProperty('--page-progress', progress);
        // }
        
        if (direction > 0) {
            if (scroll > window.innerHeight * 0.5) {
                $html.classList.add('-hide-nav');
            }
        } else {
            $html.classList.remove('-hide-nav');
        }
    }

    scrollTo(target, delay = 0, offset = 0) {
        let navbarHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'));
        let anchorsNavHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--anchors-nav-height'));
        let meaNavHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--navbar-mea-height'));
        let newOffset = offset;

        if (target != 'top' || target != 0) {
            if ($html.hasAttribute('data-mea') && $html.hasAttribute('data-anchors')) {
                newOffset = offset - navbarHeight - anchorsNavHeight - meaNavHeight;
            } else if ($html.hasAttribute('data-mea') && !$html.hasAttribute('data-anchors')) {
                newOffset = offset - navbarHeight - meaNavHeight;
            } else if ($html.hasAttribute('data-anchors') && !$html.hasAttribute('data-mea')) {
                newOffset = offset - navbarHeight - anchorsNavHeight;
            } else {
                newOffset = offset - navbarHeight;
            }
        }

        if (window.scrollY < target.offsetTop) {
            newOffset = ($html.hasAttribute('data-anchors')) ? offset - anchorsNavHeight : offset;
        }

        setTimeout(() => {
            this.scroll?.scrollTo(target, {
                duration: 1,
                lerp: 0.1,
                lock: false,
                offset: newOffset,
                // easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x)
            });
        }, delay);
    }

    initScrollToElements() {
        this.el.querySelectorAll('[data-scroll-to]').forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                let target = document.querySelector('[data-scroll-target="' + elt.getAttribute('data-scroll-to') + '"]');
                let delay = elt.getAttribute('data-scroll-to-delay') ? parseInt(elt.getAttribute('data-scroll-to-delay')) : 0;
                let offset = elt.getAttribute('data-scroll-to-offset') ? parseInt(elt.getAttribute('data-scroll-to-offset')) : 0;
                if (target) {
                    this.scrollTo(target, delay, offset);
                }
            });
        });
    }

    scrollTop(force) {
        if (!this.scroll) return;
        if (force) {
            this.scroll.scrollTo('top', { immediate: true });
        } else {
            scrollTo('top');
        }
    } 

    destroy() {
        this.scroll.destroy();
    }
}
